.card {
    overflow: hidden;
}

.header {
    padding: var(--mantine-spacing-md) var(--mantine-spacing-md) var(--mantine-spacing-sm);
}

.row {
    display: grid;
    grid-template-columns: minmax(180px, 1fr) 160px auto 72px minmax(0, 140px) 16px;
    align-items: center;
    gap: var(--mantine-spacing-lg);
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
    border-top: 1px solid var(--mt-border-default);
    box-shadow: inset 3px 0 0 var(--mt-identity-schedule);
    color: inherit;
    text-decoration: none;
}

.row:hover {
    background-color: var(--mt-surface-subtle);
}

.row:focus-visible {
    outline: 2px solid var(--mantine-primary-color-filled);
    outline-offset: -2px;
}

/* Stack the row's cells below the Mantine `sm` breakpoint. */
@media (max-width: 48em) {
    .row {
        grid-template-columns: 1fr;
        gap: var(--mantine-spacing-xs);
    }

    .chevron {
        display: none;
    }
}

.dayPills {
    display: flex;
    gap: 4px;
}

.dayPill {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: var(--mantine-radius-sm);
    background-color: var(--mantine-color-gray-1);
    color: var(--mantine-color-gray-6);
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
}

.dayPillActive {
    background-color: var(--mt-identity-schedule);
    color: var(--mantine-color-white);
}

.footer {
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
    border-top: 1px solid var(--mt-border-default);
    background-color: var(--mt-surface-subtle);
}
